<template>
    <ul class="nav--connections">
        <router-link tag="li" :to="{ name: 'Clients Connections Edit' }" :class="{'active': this.$route.name === 'Clients Connections Edit'}">
            <a href="#">{{ t('general.settings') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Categories' }" :class="{'active': this.$route.name === 'Clients Connections Categories'}">
            <a href="#">{{ t('general.categories') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Brands' }" :class="{'active': this.$route.name === 'Clients Connections Brands'}">
            <a href="#">{{ t('general.brands') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Attributes' }" :class="{'active': this.$route.name === 'Clients Connections Attributes' || this.$route.name === 'Clients Connections Attributes Add' || this.$route.name === 'Clients Connections Attributes Edit'}">
            <a href="#">{{ t('general.attributes') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Pricing' }" :class="{'active': this.$route.name === 'Clients Connections Pricing' || this.$route.name === 'Clients Connections Pricing Add' || this.$route.name === 'Clients Connections Pricing Edit'}">
            <a href="#">{{ t('general.prices') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Customer Groups' }" :class="{'active': this.$route.name === 'Clients Connections Customer Groups' || this.$route.name === 'Clients Connections Customer Groups Add' || this.$route.name === 'Clients Connections Customer Groups Edit'}">
            <a href="#">{{ t('general.customer_groups') }}</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Clients Connections Languages' }" :class="{'active': this.$route.name === 'Clients Connections Languages' || this.$route.name === 'Clients Connections Languages Add' || this.$route.name === 'Clients Connections Languages Edit'}">
            <a href="#">{{ t('general.languages') }}</a>
        </router-link>
    </ul>
</template>

<script>

export default {
    name: 'ConnectionMenu',

    props: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},
};
</script>

<style lang="scss" scoped>

    a {
        padding-bottom: 1px;
    }

    a:hover {
        text-decoration: none !important;
    }

    li:hover {
        border: 0px;
    }


</style>
